import React from "react";
import PropTypes from "prop-types";
import {MyTooltip} from "./Tooltip";
import Icon from "../../Assets/IconLibrary/Icon";
import {Link} from "react-router-dom";

export default class Button extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        let {type, disabled, className, title, onClick, children, linkedRoute, width} = this.props;

        let buttonClassName = type === "primary" || type === "buttonLink" ? "main-cta-btn" :
            type === "secondary" ? "default-secondary-btn" :
                type === "delete" ? "default-delete-btn" :
                    type === "icon" ? "menu-button" :
                        type === "link" ? "default-link-btn" :
                            type === "negativeIcon" ? "menu-button-delete" :
                                type === "exit" ? "main-exit-btn" :
                                    "default-secondary-btn";
        if (className !== undefined && className !== null) {
            buttonClassName = buttonClassName + " " + className
        }
        return (
            type === "exit" ?
                <MyTooltip title={"Close"}>
                    <button className="main-exit-btn" onClick={onClick} style={{width: width}}>
                        <Icon icon={"cross"} size={10}/>
                    </button>
                </MyTooltip>
                :
                type === "link" || type === "buttonLink" ?
                    <MyTooltip title={title}>
                        <Link className={buttonClassName} to={linkedRoute}>
                            {children}
                        </Link>
                    </MyTooltip>
                    :
                    <MyTooltip title={title}>
                        <button className={buttonClassName}
                                disabled={disabled}
                                onClick={onClick}
                                style={{width: width}}>
                            {children}
                        </button>
                    </MyTooltip>
        );
    }

}

Button.defaultProps = {
    type: "primary",
    disabled: false,
    title: "",
    linkedRoute: "/",
    width: "auto"
}

Button.propTypes = {
    type: PropTypes.oneOf(["primary", "secondary", "delete", "link", "negativeIcon", "icon", "exit", "buttonLink"]),
    disabled: PropTypes.bool,
    title: PropTypes.any,
    linkedRoute: PropTypes.string,

}
